import { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '@/core/i18n/translations';
import { getOpsStorage, setOpsStorage } from '@/shared/lib/opsStorage';

const LanguageContext = createContext({ language: 'sq', setLanguage: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    const stored = getOpsStorage('ops-language');
    return (stored === 'sq' || stored === 'en') ? stored : 'sq';
  });

  useEffect(() => {
    setOpsStorage('ops-language', language);
  }, [language]);

  const setLanguage = (lang) => {
    if (lang === 'sq' || lang === 'en') {
      setLanguageState(lang);
    }
  };

  const t = (key) => {
    const dict = translations[language];
    if (!dict) return key;
    return dict[key] ?? key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    return {
      language: 'sq',
      setLanguage: () => {},
      t: (k) => k,
    };
  }
  return ctx;
}
